/**
 * c-membership-direct-checkout.js
 *
 * メンバーシップ商品を既存カート内容に関係なく単独チェックアウトさせる。
 *
 * 対象:
 *   1. <a href="/cart/add?...selling_plan=..."> 形式の直リンク（concept / CTA / sticky-cart）
 *   2. .product-single__form のsubmit（GoSubフォーム）
 *
 * フロー:
 *   クリック/submit横取り → カート確認 → 重複ブロック or 確認モーダル → クリア → 追加 → /checkout
 */
(function () {
  'use strict';

  // ── 加入済みチェック ──
  if (document.querySelector('[data-membership-enrolled]')) return;

  // ── ヘルパー: 要素生成 ──
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    }
    if (typeof children === 'string') {
      node.textContent = children;
    } else if (Array.isArray(children)) {
      children.forEach(function (c) { node.appendChild(c); });
    }
    return node;
  }

  // ── 汎用モーダル生成 (DOM API) ──
  function createModalDOM(id, titleText, bodyText, buttons) {
    var backdrop = el('div', { 'class': 'c-mco__backdrop' });
    var title = el('p', { 'class': 'c-mco__title' }, titleText);

    var bodyP = el('p', { 'class': 'c-mco__body' });
    var lines = bodyText.split('\n');
    lines.forEach(function (line, i) {
      bodyP.appendChild(document.createTextNode(line));
      if (i < lines.length - 1) bodyP.appendChild(document.createElement('br'));
    });

    var actions = el('div', { 'class': 'c-mco__actions' }, buttons);
    var dialog = el('div', { 'class': 'c-mco__dialog', 'role': 'dialog', 'aria-modal': 'true' }, [title, bodyP, actions]);
    var overlay = el('div', { 'id': id }, [backdrop, dialog]);

    document.body.appendChild(overlay);
    return overlay;
  }

  function openModal(modal) {
    modal.classList.add('is-active');
    document.documentElement.classList.add('js-modal-open');
  }

  function hideModal(modal) {
    modal.classList.remove('is-active');
    document.documentElement.classList.remove('js-modal-open');
  }

  // ── カート内既存商品の確認モーダル ──
  function showCartClearModal() {
    var confirmBtn = el('button', {
      'type': 'button',
      'class': 'c-mco__btn c-mco__btn--confirm',
      'data-mco-confirm': ''
    }, 'そのまま進む');
    var cancelBtn = el('button', {
      'type': 'button',
      'class': 'c-mco__btn c-mco__btn--cancel',
      'data-mco-cancel': ''
    }, 'キャンセル');

    var modal = document.getElementById('c-membership-checkout-modal')
      || createModalDOM(
        'c-membership-checkout-modal',
        'カート内の商品について',
        '現在カートに入っている商品があります。\nメンバーシップのお申し込みは単独でのご購入となるため、カート内の商品は一時的に削除されます。',
        [confirmBtn, cancelBtn]
      );
    openModal(modal);
    return new Promise(function (resolve) {
      modal.querySelector('[data-mco-confirm]').onclick = function () {
        hideModal(modal);
        resolve(true);
      };
      modal.querySelector('[data-mco-cancel]').onclick = function () {
        hideModal(modal);
        resolve(false);
      };
      modal.querySelector('.c-mco__backdrop').onclick = function () {
        hideModal(modal);
        resolve(false);
      };
    });
  }

  // ── メンバーシップ重複警告モーダル ──
  function showDuplicateModal() {
    var closeBtn = el('button', {
      'type': 'button',
      'class': 'c-mco__btn c-mco__btn--confirm'
    }, '閉じる');
    var cartBtn = el('button', {
      'type': 'button',
      'class': 'c-mco__btn c-mco__btn--cancel'
    }, 'カートを確認する');

    var modal = document.getElementById('c-membership-duplicate-modal')
      || createModalDOM(
        'c-membership-duplicate-modal',
        'プランが既にカートに入っています',
        'カートにすでにメンバーシッププランが含まれています。\n別のプランを選択する場合は、カート内のプランを削除してください。',
        [closeBtn, cartBtn]
      );
    openModal(modal);
    closeBtn.onclick = function () { hideModal(modal); };
    cartBtn.onclick = function () { window.location.href = '/cart'; };
    modal.querySelector('.c-mco__backdrop').onclick = function () { hideModal(modal); };
  }

  // ── カートAPI ──
  function fetchCartJSON() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function addToCart(variantId, sellingPlanId) {
    var body = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: 1
      }]
    };
    if (sellingPlanId) {
      body.items[0].selling_plan = parseInt(sellingPlanId, 10);
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ── URLからパラメータを抽出 ──
  function parseCartAddUrl(href) {
    try {
      var url = new URL(href, window.location.origin);
      var params = url.searchParams;
      // /cart/add?items[][id]=XXX&items[][selling_plan]=YYY 形式
      var variantId = params.get('items[][id]');
      var sellingPlan = params.get('items[][selling_plan]');
      return { variantId: variantId, sellingPlanId: sellingPlan };
    } catch (e) {
      return null;
    }
  }

  // ── 共通チェックアウト処理 ──
  function handleMembershipCheckout(variantId, sellingPlanId, loadingEl) {
    function setLoading(on) {
      if (!loadingEl) return;
      if (on) {
        loadingEl.style.pointerEvents = 'none';
        loadingEl.style.opacity = '0.6';
      } else {
        loadingEl.style.pointerEvents = '';
        loadingEl.style.opacity = '';
      }
    }

    setLoading(true);

    fetchCartJSON().then(function (cart) {
      // カートに既にメンバーシップ（selling_plan付き商品）がある場合はブロック
      var hasMembership = cart.items.some(function (item) {
        return item.selling_plan_allocation != null;
      });
      if (hasMembership) {
        setLoading(false);
        showDuplicateModal();
        return;
      }

      if (cart.item_count > 0) {
        setLoading(false);
        return showCartClearModal().then(function (confirmed) {
          if (!confirmed) return;
          setLoading(true);
          return proceedCheckout(variantId, sellingPlanId, setLoading);
        });
      }
      return proceedCheckout(variantId, sellingPlanId, setLoading);
    }).catch(function () {
      setLoading(false);
    });
  }

  function proceedCheckout(variantId, sellingPlanId, setLoading) {
    return clearCart()
      .then(function () { return addToCart(variantId, sellingPlanId); })
      .then(function (data) {
        if (data.status && data.status === 422) {
          alert(data.description || '追加に失敗しました');
          if (setLoading) setLoading(false);
          return;
        }
        window.location.href = '/checkout';
      });
  }

  // ── 1. 直リンク（<a href="/cart/add?...selling_plan=...">）のインターセプト ──
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href*="/cart/add"][href*="selling_plan"]');
    if (!anchor) return;

    e.preventDefault();
    e.stopPropagation();

    var parsed = parseCartAddUrl(anchor.href);
    if (!parsed || !parsed.variantId) return;

    handleMembershipCheckout(parsed.variantId, parsed.sellingPlanId, anchor);
  }, true);

  // ── 2. フォーム送信の横取り（GoSub等） ──
  var form = document.querySelector('.product-single__form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var addBtn = form.querySelector('[data-add-to-cart]');
      if (addBtn && addBtn.disabled) return;

      var variantId = form.querySelector('select[name="id"]')?.value
        || form.querySelector('input[name="id"]')?.value;
      var sellingPlanInput = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
      var sellingPlanId = sellingPlanInput ? sellingPlanInput.value : null;

      if (!sellingPlanId) {
        var checkedRadio = form.querySelector('input[name="selling_plan"]:checked') ||
                           document.querySelector('input[name="selling_plan"]:checked');
        if (checkedRadio) sellingPlanId = checkedRadio.value;
      }

      handleMembershipCheckout(variantId, sellingPlanId, addBtn);
    }, true);
  }
})();
